"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var object_utils_1 = require("@doordash/object-utils");
var React = __importStar(require("react"));
var react_stripe_elements_1 = require("react-stripe-elements");
var VerifyPaymentCardStrings_1 = __importDefault(require("../VerifyPaymentCardStrings"));
var CardBillingAddress_1 = __importDefault(require("./CardBillingAddress"));
var CardCVV_1 = __importDefault(require("./CardCVV"));
var CardExpiration_1 = __importDefault(require("./CardExpiration"));
var CardFieldsStyles_1 = require("./CardFieldsStyles");
var cardFieldsUtils_1 = require("./cardFieldsUtils");
var CardNumber_1 = __importDefault(require("./CardNumber"));
var CardPostalCode_1 = __importDefault(require("./CardPostalCode"));
var InlineSubmit_1 = __importDefault(require("./InlineSubmit"));
var CardFields = /** @class */ (function (_super) {
    __extends(CardFields, _super);
    function CardFields() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            billingAddress: undefined,
            errors: {
                billingAddress: '',
                cardNumber: '',
                cardCVV: '',
                cardExp: '',
                postalCode: '',
                stripeError: ''
            },
            isSubmitting: false,
            validFields: {
                billingAddress: false,
                cardNumber: false,
                cardCVV: false,
                cardExp: false,
                postalCode: false
            }
        };
        _this.handleSubmit = function () {
            var _a = _this.props, onClose = _a.onClose, onFinish = _a.onFinish, onSubmit = _a.onSubmit, stripe = _a.stripe, supportBillingAddress = _a.supportBillingAddress, trackClick = _a.trackClick, trackFailure = _a.trackFailure, trackSuccess = _a.trackSuccess;
            _this.setState({
                isSubmitting: true,
                errors: {
                    stripeError: ''
                }
            });
            trackClick();
            if (supportBillingAddress && _this.isMissingBillingAddress()) {
                return;
            }
            if (stripe) {
                var billingAddress = _this.state.billingAddress;
                var createStripeToken = billingAddress
                    ? stripe.createToken(_this.sanitizeObjectKeys(billingAddress))
                    : stripe.createToken();
                createStripeToken.then(function (_a) {
                    var token = _a.token, error = _a.error;
                    if (token) {
                        onSubmit(token.id, token.card && token.card.id)
                            .then(function () {
                            trackSuccess();
                            _this.setState({
                                isSubmitting: false
                            });
                            if (onClose) {
                                onClose();
                            }
                        })["catch"](function () {
                            trackFailure({ reason: 'unknown_error' });
                            _this.setState({
                                isSubmitting: false
                            });
                            if (onFinish) {
                                onFinish();
                            }
                        });
                    }
                    if (error) {
                        trackFailure({
                            reason: 'stripe_failure',
                            message: error.message || ''
                        });
                        _this.setState({
                            isSubmitting: false,
                            errors: {
                                stripeError: error.message
                            }
                        });
                        if (onFinish) {
                            onFinish();
                        }
                    }
                });
            }
        };
        _this.clearSelectedBillingAddress = function () {
            if (_this.state.billingAddress) {
                _this.setState({
                    billingAddress: undefined,
                    errors: __assign(__assign({}, _this.state.errors), { billingAddress: VerifyPaymentCardStrings_1["default"].required() }),
                    validFields: __assign(__assign({}, _this.state.validFields), { billingAddress: false })
                });
            }
        };
        _this.handleCardBillingAddressSelection = function (address) {
            if (address) {
                _this.setState({
                    billingAddress: {
                        addressCity: address.city,
                        addressLine1: address.street,
                        addressLine2: address.subpremise,
                        addressState: address.state,
                        addressZip: address.zipCode
                    },
                    errors: __assign(__assign({}, _this.state.errors), { billingAddress: '' }),
                    validFields: __assign(__assign({}, _this.state.validFields), { billingAddress: true })
                });
            }
            else {
                _this.clearSelectedBillingAddress();
            }
        };
        _this.handleCardInputChange = function (fieldName, isEmpty, errorMessage, isComplete) {
            var _a, _b;
            _this.setState({
                errors: __assign(__assign({}, _this.state.errors), (_a = {}, _a[fieldName] = cardFieldsUtils_1.getErrorMessage(isEmpty, errorMessage), _a)),
                validFields: __assign(__assign({}, _this.state.validFields), (_b = {}, _b[fieldName] = isComplete, _b))
            });
        };
        _this.isMissingBillingAddress = function () {
            var _a = _this.state.validFields, billingAddress = _a.billingAddress, postalCode = _a.postalCode, commonFields = __rest(_a, ["billingAddress", "postalCode"]);
            if (Object.values(commonFields).every(Boolean) && !billingAddress) {
                _this.setState({
                    isSubmitting: false,
                    errors: __assign(__assign({}, _this.state.errors), { stripeError: 'Your billing address is incomplete' })
                });
                if (_this.props.onFinish) {
                    _this.props.onFinish();
                }
                return true;
            }
            return false;
        };
        return _this;
    }
    CardFields.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.submitting && this.props.submitting) {
            this.handleSubmit();
        }
    };
    CardFields.prototype.sanitizeObjectKeys = function (billingAddress) {
        var sanitizedObject = object_utils_1.snakeCaseObjectKeys(billingAddress);
        // Stripe expects the fields as address_line1 instead of address_line_1.
        sanitizedObject.address_line1 = sanitizedObject.address_line_1;
        sanitizedObject.address_line2 = sanitizedObject.address_line_2;
        delete sanitizedObject.address_line_1;
        delete sanitizedObject.address_line_2;
        return sanitizedObject;
    };
    CardFields.prototype.render = function () {
        var _this = this;
        var _a = this.state, errors = _a.errors, isSubmitting = _a.isSubmitting;
        var _b = this.props, customError = _b.customError, isInline = _b.isInline, secondCardVerifyError = _b.secondCardVerifyError, supportBillingAddress = _b.supportBillingAddress;
        var errorDisplay = null;
        // Always display stripe error if present.
        if (errors && errors.stripeError) {
            errorDisplay = errors.stripeError;
        }
        else if (secondCardVerifyError) {
            // Prioritizing custom error message, if provided.
            if (customError) {
                errorDisplay = customError;
            }
            else {
                // default to error message supplied by BFF.
                errorDisplay = cardFieldsUtils_1.getAddCardError(secondCardVerifyError);
            }
        }
        return (React.createElement(CardFieldsStyles_1.FormContainer, null,
            React.createElement(CardFieldsStyles_1.FormRow, null,
                React.createElement(CardFieldsStyles_1.NumberStyling, null,
                    React.createElement(CardNumber_1["default"], { error: errors.cardNumber, onChange: function (isEmpty, errorMessage, isComplete) {
                            return _this.handleCardInputChange('cardNumber', isEmpty, errorMessage, isComplete);
                        } })),
                React.createElement(CardFieldsStyles_1.CVVStyling, null,
                    React.createElement(CardCVV_1["default"], { error: errors.cardCVV, onChange: function (isEmpty, errorMessage, isComplete) {
                            return _this.handleCardInputChange('cardCVV', isEmpty, errorMessage, isComplete);
                        } }))),
            React.createElement(CardFieldsStyles_1.FormRow, null,
                React.createElement(CardFieldsStyles_1.InputWidth, null,
                    React.createElement(CardExpiration_1["default"], { error: errors.cardExp, onChange: function (isEmpty, errorMessage, isComplete) {
                            return _this.handleCardInputChange('cardExp', isEmpty, errorMessage, isComplete);
                        } })),
                !supportBillingAddress && (React.createElement(React.Fragment, null,
                    React.createElement(CardFieldsStyles_1.InputWidth, null,
                        React.createElement(CardPostalCode_1["default"], { error: errors.postalCode, onChange: function (isEmpty, errorMessage, isComplete) {
                                return _this.handleCardInputChange('postalCode', isEmpty, errorMessage, isComplete);
                            } })),
                    isInline && (React.createElement(CardFieldsStyles_1.InputWidth, null,
                        React.createElement(InlineSubmit_1["default"], { onSubmit: this.handleSubmit, isLoading: isSubmitting })))))),
            supportBillingAddress && (React.createElement(CardFieldsStyles_1.FormRow, null,
                React.createElement(CardFieldsStyles_1.BillingAddressStyling, null,
                    React.createElement(CardBillingAddress_1["default"], { clearSelected: this.clearSelectedBillingAddress, error: this.state.errors.billingAddress, onSelect: this.handleCardBillingAddressSelection })))),
            React.createElement(design_language_1.Stack, null),
            !isSubmitting && errorDisplay && (React.createElement(CardFieldsStyles_1.AddCardError, null,
                React.createElement(design_language_1.Text, null, errorDisplay)))));
    };
    return CardFields;
}(React.Component));
exports["default"] = react_stripe_elements_1.injectStripe(CardFields);
